/**
 * Ảnh mẫu (Unsplash) — chọn theo id/slug ổn định, không đổi mỗi lần render.
 * salt khác nhau → ảnh phụ (thumbnail) khác ảnh chính.
 */
const POOL = [
  "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?auto=format&fit=crop&w=640&q=80",
  "https://images.unsplash.com/photo-1469474968028-56623f02e42e?auto=format&fit=crop&w=640&q=80",
  "https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?auto=format&fit=crop&w=640&q=80",
  "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=640&q=80",
  "https://images.unsplash.com/photo-1516026672322-bc52d61a55d5?auto=format&fit=crop&w=640&q=80",
  "https://images.unsplash.com/photo-1528127269322-539801943592?auto=format&fit=crop&w=640&q=80",
  "https://images.unsplash.com/photo-1501785888041-af3ef285b470?auto=format&fit=crop&w=640&q=80",
  "https://images.unsplash.com/photo-1439066615861-d1af74d74000?auto=format&fit=crop&w=640&q=80",
  "https://images.unsplash.com/photo-1493246507139-2e8f877bba04?auto=format&fit=crop&w=640&q=80",
  "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=640&q=80",
  "https://images.unsplash.com/photo-1519681393784-d120267933ba?auto=format&fit=crop&w=640&q=80",
  "https://images.unsplash.com/photo-1470071459604-3b5ec3a7fe05?auto=format&fit=crop&w=640&q=80",
];

function hashItem(id, slug = "", salt = 0) {
  const s = `${id}::${slug || ""}::${salt}`;
  let h = 0;
  for (let i = 0; i < s.length; i += 1) {
    h = Math.imul(31, h) + s.charCodeAt(i) | 0;
  }
  return Math.abs(h);
}

export function getPlaceholderForItem(item, salt = 0) {
  const id = item?.id ?? item?._id ?? "0";
  const slug = item?.slug ?? "";
  return POOL[hashItem(id, slug, salt) % POOL.length];
}

/** Có URL ảnh hợp lệ không (string không rỗng) */
export function hasUsableImageUrl(url) {
  return typeof url === "string" && url.trim().length > 8;
}
